import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CadastroEnderecoModule } from './../common/cadastro-endereco/cadastro-endereco.module';

import { NgxCurrencyModule } from 'ngx-currency';
import { SharedDirectivesModule } from 'src/app/directives/shared-directives.module';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { ComboFuncionarioModule } from "../common/combo-funcionario/combo-funcionario.module";
import { PessoaFisicaModule } from '../common/pessoa-fisica/pessoa-fisica.module';
import { CadastrarFuncionarioComponent } from './cadastrar-funcionario/cadastrar-funcionario.component';
import { CadastrarDependentesComponent } from './dependentes/cadastrar-dependentes/cadastrar-dependentes.component';
import { DependentesComponent } from './dependentes/dependentes.component';
import { ListarDependentesComponent } from './dependentes/listar-dependentes/listar-dependentes.component';
import { FuncionarioRoutingModule } from './funcionario-routing.module';
import { FuncionarioComponent } from './funcionario.component';


@NgModule({
  declarations: [FuncionarioComponent, CadastrarFuncionarioComponent, DependentesComponent, ListarDependentesComponent, CadastrarDependentesComponent],
  imports: [
    CommonModule,
    NgxCurrencyModule,
    FuncionarioRoutingModule,
    PessoaFisicaModule,
    MaterialCommonModule,
    CadastroEnderecoModule,
    SharedDirectivesModule,
    ComboFuncionarioModule
  ]
})
export class FuncionarioModule { }
